import { ResponsiveLine } from "@nivo/line";
import WidgetContainer from "./widget-container";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createComponentStore } from "easy-peasy";
import DashboardModel from "Store/models/dashboard";
import moment from "moment";
import { Spin } from "antd";

const useStore = createComponentStore(DashboardModel("totalcontractvalues"));

export default function TotalContractValuesChart({ ...props }) {
  const [store, actions] = useStore();
  const [loading, setLoading] = useState(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const asyncSetChartData = async () => {
      setLoading(true);
      let startDate = moment(moment().subtract(6, "months"));
      let data = [
        { id: "Nakit Akışı", data: [] },
        { id: "Tahsilatlar", data: [] },
        { id: "Alacak", data: [] },
        { id: "Borç", data: [] },
      ];
      for (let i = 0; i < 12; i++) {
        let month = startDate.get("M") + 1;
        let year = startDate.get("Y");

        const response = await actions.fetch({ month: month, year: year });
        if (response) {
          data[0].data.push({
            x: `${month}/${year}`,
            y: response[0].totalCashflow,
          });
          data[1].data.push({
            x: `${month}/${year}`,
            y: response[0].totalPayment,
          });
          data[2].data.push({
            x: `${month}/${year}`,
            y: response[0].totalDebt,
          });
          data[3].data.push({
            x: `${month}/${year}`,
            y: response[0].totalCredit,
          });
        }

        startDate = startDate.add(1, "months");
      }

      setChartData(data);
      setLoading(false);
    };

    asyncSetChartData();
  }, []);

  return (
    <Spin spinning={loading}>
      <WidgetContainer
        height="40vh"
        title="Gelir Grafiği"
        icon={() => <FontAwesomeIcon icon={["fas", "chart-line"]} />}
      >
        <ResponsiveLine
          data={chartData}
          margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: false,
            reverse: false,
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Ay/Yıl",
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Tutar",
            legendOffset: -40,
            legendPosition: "middle",
          }}
          colors={{ scheme: "nivo" }}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      </WidgetContainer>
    </Spin>
  );
}
